import { createAction } from "redux-actions";

export const FOCUS_VIEW_OVERVIEW = "overview";
export const FOCUS_VIEW_TYPES = [FOCUS_VIEW_OVERVIEW];

export const BREADCRUMBS_CLICK_OVERVIEW = "BREADCRUMBS_CLICK_OVERVIEW";
export const breadcrumbsClickOverview = createAction(BREADCRUMBS_CLICK_OVERVIEW);
export const crumbOverviewClick = () => () => () => {
  // dispatch(breadcrumbsClickOverview({ focusViewType: FOCUS_VIEW_OVERVIEW }));
};
